import { useIntl } from '@apigrowfinance/pbolt-intl-provider';

import { AddressDetails } from '@clients/accountsClient';
import { getCountryTranslations } from '@utils/countryTranslations';
interface formatAddressProps {
    type: 'title' | 'descriptive';
    address: AddressDetails;
}

export const FormatAddress = ({ type, address }: formatAddressProps) => {
    const { locale } = useIntl();

    switch (type) {
        case 'title':
            return [
                address?.city,
                getCountryTranslations(address?.country, locale),
                address?.zip_code,
            ]
                .filter(Boolean)
                .join(', ');
        case 'descriptive':
            return [
                address?.address,
                address?.complementary_address,
                address?.neighborhood,
                address?.city,
                getCountryTranslations(address?.country, locale),
                address?.zip_code,
            ]
                .filter(Boolean)
                .join(', ');
        default: {
        }
    }
};
